import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withFirebase } from '../Firebase';
import * as ROUTES from '../../constants/routes';

import "./ButtonCreate.css";

class CreateCapsule extends Component {

    render() {

        let width = window.innerWidth;
        if (width > 768) {
            return (
                    <CreateCapsuleComponent />
            );
        } else {
            return (
                <div>
                    <CreateCapsuleComponentMobile />
                </div>
            );
        }
    }
}

class CreateCapsuleComponentBase extends Component {

    redirectCreateCapsule = event => {
        this.props.history.push(ROUTES.CHALLENGE);
    }

    render (){
        return (
        <div className="btn-capsule-container">
            <button className="btn-capsule" onClick={this.redirectCreateCapsule}>
                <img src={require('../../assets/home/Plus_desktop.svg')} alt='Plus'/>
                <div className="btn-text">Créer une capsule</div>
            </button>
         </div>
         );
    };
}

class CreateCapsuleComponentBaseMobile extends Component {

    redirectCreateCapsule = event => {
        this.props.history.push(ROUTES.CHALLENGE);
    }

    render (){
        return (
        <div className="btn-capsule-container-mobile">
                <img src={require('../../assets/home/Plus_mobile.svg')} alt='Plus' onClick={this.redirectCreateCapsule}/>
         </div>
         );
    };
}

const CreateCapsuleComponent = withRouter(withFirebase(CreateCapsuleComponentBase));
const CreateCapsuleComponentMobile = withRouter(withFirebase(CreateCapsuleComponentBaseMobile));

export default CreateCapsule;
export { CreateCapsuleComponent, CreateCapsuleComponentMobile };